/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_Switcher_LabelInputs */

const en_language_switcher_label = /** @type {(inputs: Language_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const fr_language_switcher_label = /** @type {(inputs: Language_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue`)
};

const ms_sg2_language_switcher_label = /** @type {(inputs: Language_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Language_Switcher_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const language_switcher_label = /** @type {((inputs?: Language_Switcher_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_Switcher_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_language_switcher_label(inputs)
	if (locale === "fr") return fr_language_switcher_label(inputs)
	return ms_sg2_language_switcher_label(inputs)
});